import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Filters } from '../../implementation-specialist/models/reportsFilters';
import { RootState } from '../../shared/state/root-reducer';
import { AppDispatch } from '../../shared/state/store';
import { clearReportInfo } from '../state/users/admin-slice';
import { handleGetFilteredReports } from '../state/users/admin-thunk';
import AdminReports from './admin-users/admin-reports-filter';
import { ReportFilterModal } from './admin-users/report-filters-modal';
import QuickSightDashboardFrame from './reports-qsf';

interface ReportsProps {
  page: "admin" | "client-owner";
}

function ReportsViewFrame(props: ReportsProps) {

  const dispatch = useDispatch<AppDispatch>();
  // eslint-disable-next-line
  const [showReportFiltersModal, setShowReportFiltersModal] = useState(false)
  const [exportedReportName, setExportedReportName] = useState("")

  const stateFields = {
    filteredReport: useSelector(
      (state: RootState) => state.adminContext.adminUserContext.filteredReport
    ),
    allReports: useSelector(
      (state: RootState) => state.adminContext.adminUserContext.allReports
    ),
    isLoading: useSelector(
      (state: RootState) => state.adminContext.adminUserContext.isReportsLoading
    ),
    csvData: useSelector(
      (state: RootState) => state.adminContext.adminUserContext.csvData
    ),
    reportFilters: useSelector(
      (state: RootState) => state.adminContext.adminUserContext.reportFilters
    )
  }

  function handleFilterReportCancel() {
    setShowReportFiltersModal(false);
  }

  function handleFilterReportSubmit() {
    setShowReportFiltersModal(false);
  }


  useEffect(() => {
    dispatch(clearReportInfo())
  }, [dispatch])


  function handleFilterReportType(reportsFilters: Filters) {
    dispatch(handleGetFilteredReports(reportsFilters));
  }

  useEffect(() => {
    const {reportType, startDate, endDate} = stateFields.reportFilters
    if (!startDate || !endDate) setExportedReportName(reportType);
    else setExportedReportName(`${reportType} from ${startDate} to ${endDate}`);
  }, [stateFields.reportFilters])

  const reportsUsersView = (
    <Grid container spacing={2}>
      <Grid item xs={3}>
        {/* <AdminReports handleFilterReportType={handleFilterReportType} /> */}
      </Grid>
      <Grid item xs={9}>
        <QuickSightDashboardFrame />
      </Grid>
    </Grid>
  );

  return (
    <main>
      <div className="content fullwidth">
        {reportsUsersView }
      </div>

      <ReportFilterModal
        title= {stateFields.reportFilters.reportType}
        open={showReportFiltersModal}
        handleFilterReportCancel={handleFilterReportCancel}
        handleFilterReportSubmit={handleFilterReportSubmit}
      />
    </main>
  );
}

export default ReportsViewFrame;
